<template>
    <div :class="['techVideo']">      
        <div class="tvWrapper">
          <div class="tvVideo">
              <iframe 
                src="https://player.vimeo.com/video/1033482433" 
                style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" 
                frameborder="0" webkitallowfullscreen="" mozallowfullscreen="" allowfullscreen="">
              </iframe>              
          </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { splitLines } from "@/utils";

export default {
    name: "techVideo",
    components:{},
    props: {
        visible:Boolean,
        sectionDataIndex:Number,
        isNavOpen: Boolean
    },
    data()
    {
        return {
            plaformIndex:-1,
            infoImg:'',
            isTechFadeout:true
        }
    },
    watch: {
    },
    methods:
    {
      onItemChange(catalogNo)
      {
        //nothing
      },
    },
    computed:{
        ...mapState(["xSelectedPlatform","minisite_data","siteDataReady"]),
        sectionData(){
            return "";//this.minisite_data.SECTIONS[this.sectionDataIndex];
        }

    }
};
</script>


<style>
    .techVideo
    {
        background: transparent;
        width: 100%;
        height: 100%;   
        position: relative;     
        display: flex;        
    }    
    .techVideo.visible
    {
      display: block;
    }
    .tvWrapper
    {
      width: 100vw;
    }
    .tvVideo
    {
        position: relative;
        height: 40vw;
        width: calc(100% - 6vw);
        margin: auto;
        opacity: 1;
    }


  @media (hover: hover) {
  }

  @media (max-width: 850px) { 


  }  
</style>